export const Data = [
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
  {
    image: "images/Dashimages/card01.png",
    name: "item",
    rate: "4.1",
    para: "Hi! This site is Amazing",
    ticket: "Ticket 5$",
    time: "50:40:03",
  },
];
